export const iconsNavMenu = {
  home: (className) => <i className={`uil uil-estate ${className}`}></i>,
  user: (className) => <i className={`uil uil-user ${className}`}></i>,
  file: (className) => <i className={`uil uil-file-alt ${className}`}></i>,
  service: (className) => (
    <i className={`uil uil-briefcase-alt ${className}`}></i>
  ),
  portfolio: (className) => <i className={`uil uil-scenery ${className}`}></i>,
  contact: (className) => <i className={`uil uil-message ${className}`}></i>,
};
